import { render, staticRenderFns } from "./textbook_category_select.vue?vue&type=template&id=62b1df7f&"
import script from "./textbook_category_select.vue?vue&type=script&lang=js&"
export * from "./textbook_category_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports